var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.loading
        ? _c("v-skeleton-loader", {
            staticClass: "mx-auto",
            attrs: {
              "max-width": "300",
              type: "list-item, list-item, list-item",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.reschedules
        ? _c(
            "v-list",
            _vm._l(_vm.reschedules, function (reschedule) {
              return _c(
                "v-list-item",
                { key: reschedule.id },
                [
                  _c(
                    "v-list-item-content",
                    { staticClass: "py-1" },
                    [
                      _c("BookingCancelledLesson", {
                        attrs: {
                          type: reschedule.type,
                          instrument: reschedule.instrument,
                          duration: reschedule.duration,
                          event: reschedule.group_event,
                          reschedule_minutes: reschedule.reschedule_minutes,
                          reschedule_pass: reschedule.reschedule_pass,
                          dateTime: _vm.globalMomentFullDateAtTimeShort(
                            reschedule.starts_at
                          ),
                        },
                        on: {
                          input: function ($event) {
                            return _vm.$emit("input", reschedule)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }